import { render, staticRenderFns } from "./IconCheckMark.vue?vue&type=template&id=d6e05f36&"
import script from "./IconCheckMark.vue?vue&type=script&lang=js&"
export * from "./IconCheckMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports